export default __webpack_public_path__ + "static/media/Honor Roll.1dbf9c38.JPG";